import { EMAIL_PLACEHOLDERS } from "./emailUtils";

const PLACEHOLDER_REGEX = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;
const KNOWN_KEYS = new Set(EMAIL_PLACEHOLDERS.map(({ key }) => key));

const escapeHtml = (value) =>
  String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

export const formatEmailPreviewDate = (date = new Date()) =>
  new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(date);

export const formatPreviewPersonName = (value) => {
  const name = String(value || "")
    .trim()
    .replace(/\s+/g, " ");
  if (!/[a-z]/i.test(name) || name !== name.toUpperCase()) return name;
  return name
    .toLowerCase()
    .replace(
      /(^|[\s'-])([a-z])/g,
      (_, separator, letter) => `${separator}${letter.toUpperCase()}`,
    );
};

const replacePreviewPlaceholders = (value, replacements, htmlEscape) =>
  String(value || "").replace(PLACEHOLDER_REGEX, (token, key) => {
    if (!KNOWN_KEYS.has(key)) return token;
    const replacement = String(replacements[key] ?? "");
    return htmlEscape
      ? escapeHtml(replacement)
      : replacement.replace(/\r|\n/g, " ");
  });

export const renderEmailPreview = ({
  subject,
  body,
  recipientEmail = "",
  recipientName = "",
  packageValues = {},
  currentDate = new Date(),
}) => {
  const replacements = {
    contractor_name: formatPreviewPersonName(packageValues.contractor_name),
    company_name: packageValues.company_name || "",
    signing_link: packageValues.signing_link || "",
    recipient_name: recipientName,
    recipient_email: recipientEmail,
    current_date: formatEmailPreviewDate(currentDate),
  };

  return {
    subject: replacePreviewPlaceholders(subject, replacements, false),
    bodyHtml: replacePreviewPlaceholders(body, replacements, true),
  };
};
